import { processCollectionMeta } from '../../processing/collectionMeta';
import { fetchChannel } from '../../services';

export async function fetchCollectionMeta(id: number) {
  const channel = await fetchChannel({ id });

  return processCollectionMeta(channel);
}
